import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoToAudioConverterConfig } from '@/data/landingConfig/landingVideoToAudioConverterConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoToAudioConverter } from './schemaObject';

interface Props {}
const VideoToAudioConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoToAudioConverter} />
			<VideoLandingTemplate
				data={landingVideoToAudioConverterConfig}
				funnelLinkService={GenerateLandingLinkService.funnelVideoConverter()}
			/>
		</>
	);
};

export default VideoToAudioConverter;
